import React, { useState, useEffect } from 'react';

// Chỉ import đích danh các component phụ trợ để tối ưu Tree-shaking
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import ContainerGrid from "./ContainerGrid";//Sử dụng Grid này thay cho Grid của MUI để nó response theo container thay vì màn hình thiết bị
import {loadBabelOnce} from "../utils";
import { bienDichComponent } from './bienDichJsx';//Biên dịch script JSX -> component (an toàn với hàm phụ Babel chèn đầu mã)

// =====================================================================
// COMPONENT LÕI: TRÌNH BIÊN DỊCH GIAO DIỆN ĐỘNG (RUNTIME COMPILER)
// =====================================================================
const DynamicCustomForm = ({ script, formData, setFormData, handleFieldChange,handleSaveClick,handleCloseRequest, formErrors, renderField, context }) => {
  // ĐÃ SỬA: Thêm biến MUI vào state để lưu giữ sau khi tải động
  const [CompilerConfig, setCompilerConfig] = useState({ Component: null, MUI: null, error: null, isLoading: true });

  useEffect(() => {
    let isMounted = true;
    
    const compileScript = async () => {
      try {
        setCompilerConfig(prev => ({ ...prev, isLoading: true, error: null }));

        // 1. TẢI ĐỘNG (LAZY-LOAD) BABEL VÀ TOÀN BỘ THƯ VIỆN MUI CÙNG LÚC
        const loadBabel = loadBabelOnce();
        const [Babel, DynamicallyLoadedMUI] = await Promise.all([
          loadBabel,
          import('@mui/material') // Tải động toàn bộ MUI (Sẽ tách thành chunk riêng)
        ]);

        // 2. PHÂN TÍCH SCRIPT CỦA USER VÀ KIỂM TRA TÍNH TƯƠNG THÍCH
        let scriptBody = script;
        if (!scriptBody.includes("return ")) {
            scriptBody = "return (\n<React.Fragment>\n" + scriptBody + "\n</React.Fragment>\n);";
        }

        // 3. BỌC SCRIPT THÀNH REACT FUNCTIONAL COMPONENT
        const wrappedScript = 
          "(function UserCustomForm(props) {\n" +
          "  const { MUI, React, formData, setFormData, handleFieldChange, formErrors, renderField, context } = props;\n" +
          "  " + scriptBody + "\n" +
          "})";

        // 5. DỊCH JSX + KHỞI TẠO COMPONENT ("use strict" và hàm phụ Babel chèn đầu mã do bienDichJsx lo)
        const UserComponent = bienDichComponent(Babel, wrappedScript, ['React', 'MUI', 'ContainerGrid'], [React, DynamicallyLoadedMUI, ContainerGrid]);

        // ĐÃ SỬA: Lưu DynamicallyLoadedMUI vào State
        if (isMounted) {
            setCompilerConfig({ 
                Component: UserComponent, 
                MUI: DynamicallyLoadedMUI, 
                ContainerGrid,
                error: null, 
                isLoading: false 
            });
        }
      } catch (err) {
        console.error("Lỗi biên dịch Custom Form:\n", err);
        if (isMounted) setCompilerConfig({ Component: null, MUI: null, error: err.message, isLoading: false });
      }
    };

    if (script) {
        compileScript();
    } else {
        if (isMounted) setCompilerConfig({ Component: null, MUI: null, error: null, isLoading: false });
    }
    
    return () => { isMounted = false; };
  }, [script]);

  if (CompilerConfig.isLoading) return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', p: 3, justifyContent: 'center' }}>
      <CircularProgress size={24} />
      <Typography color="text.secondary">Đang tải tài nguyên và biên dịch giao diện...</Typography>
    </Box>
  );

  if (CompilerConfig.error) return (
    <Alert severity="error" sx={{ m: 2, borderRadius: 2 }}>
      <strong>Lỗi biên dịch Code Giao diện:</strong> {CompilerConfig.error}
    </Alert>
  );

  // ĐÃ SỬA: Bóc tách MUI ra từ State để xài
  const { Component, MUI } = CompilerConfig;
  if (!Component || !MUI) return null;

  // Render Component của User và bơm các công cụ (tools) vào
  return (
    <Component 
      formData={formData} 
      setFormData={setFormData} 
      handleFieldChange={handleFieldChange} 
      handleSaveClick={handleSaveClick}
      handleCloseRequest={handleCloseRequest}
      formErrors={formErrors} 
      renderField={renderField} 
      context={context} 
      MUI={MUI}
      ContainerGrid={ContainerGrid}
      React={React} 
    />
  );
};

export default DynamicCustomForm;